import { http } from "@/utils/http";

function getOrderStatusDisplay(status) {
  let display = this.orderStatusList[status];
  if (display) {
    return display;
  } else {
    return this.extraOrderStatusList[status] || status;
  }
}

function getStatusByDisplay(display) {
  for (let key in this.orderStatusList) {
    if (this.orderStatusList[key] === display) {
      return key;
    }
  }
  return display;
}

function getShipCompanyByDisplay(display) {
  for (let key in this.shipCompanyList) {
    if (this.shipCompanyList[key] === display) {
      return key;
    }
  }
  return display;
}

function getIncomeTypeDisplay(incomeType) {
  return this.orderIncomeTypeList[incomeType] || incomeType;
}

function getCompanyDisplay(companyCode) {
  let companies = this.getCompanies();
  if (companyCode === "all") {
    return "全部";
  }
  return companies[companyCode] || companyCode;
}

function getOrderFilterDisplay(query) {
  return this.orderFilterList[query] || query;
}

function getTaskStatusDisplay(query) {
  return this.taskStatusList[query] || query;
}

function getShipCompanyDisplay(query) {
  return this.shipCompanyList[query] || query;
}

function getOrderStatusLevel(order) {
  // 删除显示删除标记
  if (order.deleted) {
    return "table-dark";
  }
  // 快递原因不能发货的, 显示正常
  if (order.status === "should_not_sent") {
    return "";
  }

  // sent显示success
  if (order.status === "sent" || order.status === "refunded") {
    return "table-success";
  }
  // 未下载
  if (!order.downloaded_at || !order.due_by) {
    return "";
  }

  let time1 = new Date();
  let time2 = new Date(order.due_by);
  let diff = time2 - time1;

  // 48小时显示warning
  // 超时显示danger
  if (diff < 0) {
    return "table-danger";
  } else if (diff < 24 * 60 * 60 * 1000) {
    return "table-warning";
  } else {
    return "";
  }
}

function calculateOrderItemsCount(order) {
  // 订单分几册
  var count = 0;
  for (let i = 0; i < order.files.length; i++) {
    let file = order.files[i];
    if (file.product_code.toLowerCase().endsWith("-inner")) {
      count++;
    }
  }
  return count;
}

function renderOrderItems(order) {
  let shard = calculateOrderItemsCount(order);
  let count = order.count;
  let extraClass = "";
  if (count > 1 || shard > 1) {
    extraClass = 'class="text-danger"';
  }
  return `<span ${extraClass}>${shard} 册 X ${count} 份</span>`;
}

function getCompanies() {
  // 从localstorage获取公司的数据，如果数据存在且没有过期直接返回
  let data = localStorage.getItem("companyList");
  if (data) {
    data = JSON.parse(data);
    if (data.expiredAt > Date.now()) {
      return data.companies;
    }
  }

  // 没有则向服务器请求
  http.get("/api/companies").then(response => {
    let records = {};
    for (let i = 0; i < response.data.data.length; i++) {
      records[response.data.data[i].company_code] =
        response.data.data[i].nickname;
    }

    let result = {
      companies: records,
      expiredAt: Date.now() + 1 * 24 * 60 * 60 * 1000
    };

    localStorage.setItem("companyList", JSON.stringify(result));
    return records;
  });
  // 尽管缓存过期了，还是要返回旧的数据
  return !data ? {} : data.companies;
}

function computeCompanyButtonGroup() {
  let companyGroup = {};
  companyGroup.name = "公司";
  companyGroup.value = "";
  companyGroup.key = "company_code";
  companyGroup.menus = [];
  companyGroup.display = {
    name: "全部公司",
    value: ""
  };
  let companies = this.getCompanies();
  companyGroup.menus.push({
    name: "全部公司",
    value: ""
  });
  for (let key in companies) {
    companyGroup.menus.push({
      name: companies[key],
      value: key
    });
  }
  return companyGroup;
}

function computeShipCompanyButtonGroup() {
  let shipGroup = {};
  shipGroup.name = "快递";
  shipGroup.value = "";
  shipGroup.key = "ship_company";
  shipGroup.menus = [];
  shipGroup.display = {
    name: "快递",
    value: ""
  };

  shipGroup.menus.push({
    name: "全部",
    value: ""
  });

  for (let key in this.shipCompanyList) {
    shipGroup.menus.push({
      name: this.shipCompanyList[key],
      value: key
    });
  }

  return shipGroup;
}

function computeOrderStatusGroup() {
  let statusGroup = {};
  statusGroup.name = "状态";
  statusGroup.value = "";
  statusGroup.key = "status";
  statusGroup.origin = {
    name: " 全部状态",
    value: ""
  };
  statusGroup.menus = [];
  for (let key in this.orderStatusList) {
    statusGroup.menus.push({
      name: this.orderStatusList[key],
      value: key
    });
  }
  return statusGroup;
}

function getDeliveryStatusDisplay(status) {
  return this.deliveryStatusDisplay[status] || status;
}

export default {
  data() {
    return {
      orderStatusList: {
        all: "全部状态",
        not_finished: "未完成",
        created: "创建",
        create_failed: "创建失败",
        downloading: "下载中",
        downloaded: "下载完毕",
        download_failed: "下载失败",
        markup: "拼版中",
        markup_succeeded: "拼版成功",
        markup_failed: "拼版失败",
        // pre_print: '待打印',
        // printing: '打印中',
        printed: "已打印",
        manually_processed: "人工制作",
        packaged: "分拣包装",
        ship_no: "有运单号",
        sent_wait: "待取件",
        waiting: "等待其他订单",
        sent: "已发货",
        post_sale: "售后",
        deleted: "删除",
        should_not_sent: "快递原因不能发货"
        // refunded: '已退款'
      },
      orderIncomeTypeList: {
        delivery: "运费",
        basic: "基础价",
        extra_p: "加P价",
        packaging: "包装费",
        other: "其他",
        manual: "手动收费"
      },
      extraOrderStatusList: {
        not_finished: "未完成" //  搜索用
      },
      orderFilterList: {
        all: "全部订单",
        order_no: "内部订单号",
        company_order_no: "外部订单号",
        product_code: "产品代码",
        ship_no: "快递号",
        consignee_phone: "手机号",
        consignee_name: "收件人"
      },
      taskStatusList: {
        created: "创建",
        running: "运行中",
        succeeded: "执行成功",
        cancelled: "任务撤销",
        failed: "执行失败"
      },
      shipCompanyList: {
        shunfeng: "顺丰",
        shunfengguoji: "顺丰国际",
        yuantong: "圆通",
        zhongtong: "中通",
        youzheng: "邮政快递包裹",
        youzhengbiaokuai: "邮政国内标快",
        shentong: "申通",
        yunda: "韵达",
        EMS: "EMS"
      },
      deliveryStatusDisplay: {
        created: "暂无走件记录",
        shipping: "运输中",
        received: "已收件",
        problem: "问题件"
      }
    };
  },
  methods: {
    getOrderStatusDisplay,
    getStatusByDisplay,
    getCompanyDisplay,
    getIncomeTypeDisplay,
    getOrderFilterDisplay,
    getTaskStatusDisplay,
    getShipCompanyDisplay,
    getOrderStatusLevel,
    getShipCompanyByDisplay,
    getCompanies,
    calculateOrderItemsCount,
    renderOrderItems,
    computeOrderStatusGroup,
    computeCompanyButtonGroup,
    computeShipCompanyButtonGroup,
    getDeliveryStatusDisplay
  }
};
